import type { PaymentDetails } from '@/shared/api/types'
import { coinOf } from '@/shared/lib/currencies'
import { crypto } from '@/shared/lib/format'
import styles from './Payment.module.css'

/**
 * «N из M подтверждений».
 *
 * Полоса, а не строка текста: перевод в биткоине ждёт до часа, и всё
 * это время плательщик смотрит на экран, пытаясь понять, не завис ли
 * он. Видимое движение — единственное, что отличает «идёт» от
 * «сломалось», а решив, что сломалось, человек платит второй раз.
 *
 * Адреса на этом экране нет намеренно: деньги уже отправлены.
 */
export function Confirming({ payment }: { payment: PaymentDetails | null }) {
  if (payment === null) return null
  const ticker = coinOf(payment.currency).ticker
  const required = payment.required_confirmations
  // Ноль в знаменателе — «счётчик ещё не запущен», а не «готово».
  // Нарисованная от нуля полоса показала бы 100% на пустом месте.
  const known = required > 0
  const done = known ? Math.min(payment.confirmations, required) : 0
  const ratio = known ? done / required : 0

  return (
    <div className={styles.confirming}>
      <div className={styles.confirmHead}>
        <span className={styles.confirmTitle}>Платёж получен</span>
        <span className={styles.confirmCount}>
          {known ? `${done} из ${required}` : 'ждём сеть'}
        </span>
      </div>

      <div
        className={styles.bar}
        role="progressbar"
        aria-label="Подтверждения сети"
        aria-valuemin={0}
        aria-valuemax={known ? required : 1}
        aria-valuenow={done}
        aria-valuetext={known ? `${done} из ${required} подтверждений` : 'ожидание сети'}
      >
        <span className={styles.barFill} style={{ width: `${Math.round(ratio * 100)}%` }} />
      </div>

      <span className={styles.confirmSum}>
        Получено {crypto(payment.received_amount ?? payment.paid_amount)} {ticker}
      </span>
    </div>
  )
}
